import React from 'react';
import PropTypes from 'prop-types';
import { GatsbyImage } from 'gatsby-plugin-image';

import getProperImageData from 'utils/getProperImageData';
import { gatsbyImageDataShape } from 'utils/propTypes';

import { StyledButtonSurveyWrapper, HiddenButtonSurvey, StyledButtonSurveyLabel } from './styles';

const CheckboxItem = ({ name, label, media, localMedia, isInline, isSelected, onSelect }) => {
  const properImage = (localMedia && getProperImageData(localMedia)) || media;
  const hasMedia = !!properImage?.gatsbyImageData;

  return (
    <StyledButtonSurveyWrapper
      data-test="styled-button"
      isSelected={isSelected}
      hasMedia={hasMedia}
      isInline={isInline}
    >
      <HiddenButtonSurvey type="checkbox" name={name} checked={isSelected} onChange={onSelect} />
      {properImage?.gatsbyImageData ? <GatsbyImage image={properImage.gatsbyImageData} alt={label} /> : null}
      <StyledButtonSurveyLabel isInline={isInline} hasMedia={hasMedia}>
        {label}
      </StyledButtonSurveyLabel>
    </StyledButtonSurveyWrapper>
  );
};

export default CheckboxItem;

CheckboxItem.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  media: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    gatsbyImageData: gatsbyImageDataShape,
  }),
  localMedia: PropTypes.object,
  isInline: PropTypes.bool,
  isSelected: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
};
